import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  CompanyExtraFields,
  CompanyFields,
  PartialCommissionExtraFields,
  PartialCommissionFields,
} from "../schema";

type ApiRequestConfig = Config<CompanyFields, CompanyExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialCommissionFields,
  PartialCommissionExtraFields
>;

export const getAccountCompanies = (config?: ApiRequestConfig) => {
  return api.get<CompanyFields, CompanyExtraFields>(
    `account_companies`,
    config
  );
};

export const getAccountCompany = (id: number, config?: ApiRequestConfig) => {
  return api.get<CompanyFields, CompanyExtraFields>(
    `account_companies/${id}`,
    config
  );
};

export const createAccountCompany = (config?: ApiRequestConfigMutate) => {
  return api.create<CompanyFields, CompanyExtraFields>(
    `account_companies`,
    config
  );
};

export const updateAccountCompany = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<CompanyFields, CompanyExtraFields>(
    `account_companies/${id}`,
    config
  );
};

export const deleteAccountCompany = (id: number) => {
  return api.remove<CompanyFields, CompanyExtraFields>(
    `account_companies/${id}`
  );
};
